/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Canceled_ToInputs */

const en_admin_membership_confirmations_canceled_to = /** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled to`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const de_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const es_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const fr_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const it_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const pl_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const hu_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/** @type {(inputs: Admin_Membership_Confirmations_Canceled_ToInputs) => LocalizedString} */
const ro_admin_membership_confirmations_canceled_to = en_admin_membership_confirmations_canceled_to;

/**
* | output |
* | --- |
* | "Canceled to" |
*
* @param {Admin_Membership_Confirmations_Canceled_ToInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_canceled_to = /** @type {((inputs?: Admin_Membership_Confirmations_Canceled_ToInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Canceled_ToInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "de") return de_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "es") return es_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "it") return it_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_canceled_to(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_canceled_to(inputs)
	return ro_admin_membership_confirmations_canceled_to(inputs)
});
export { admin_membership_confirmations_canceled_to as "admin.membership_confirmations.canceled_to" }